import React, { useState, useEffect } from 'react'
import { getWhatsappTemplateForEv, getCommunicationPreiviwTempalteByTemplateId, sendDirectTemplateUsingTempalteidAndType } from '../../../../AdminActionCreator.component'
import Loader from '../../../../../../presentationals/Loader/Loader.component'

export default function Whatsapp({ userDetail }) {
    const [selectedTemplate, setselectedTemplate] = useState({ value: "", data: {} })
    const [loader, setLoader] = useState(false)
    const [templateList, setTemplateList] = useState([])
    const [previewData, setPreviewData] = useState("")
    const [Msg, setMsg] = useState({ show: false, popupStatus: "",color:"" })

    const handleSelectedMsg = (e) => {
        const Selectedvalue = e.target.value;
        const obj = templateList?.filter((el) => el?.whatsappId == Selectedvalue)
        console.log("obj,",obj)
        setselectedTemplate({ value: Selectedvalue, data: obj[0] })
        getCommunicationPreiviwTempalteByTemplateIdFn(Selectedvalue)
    }

    const SendMsg = (e) => {
        setLoader(true)
               console.log("selectedTemplate,",selectedTemplate)
        sendDirectTemplateUsingTempalteidAndType(selectedTemplate?.data?.whatsappId, "WHATSAPP", userDetail?.userId, callback => {
            setLoader(false)
            if (callback == "success") {
                setMsg({
                    show: true,
                    popupStatus: "Message Sent Successfully",
                    color:"#267dff"
                })
                setPreviewData("")
                setselectedTemplate({ value: "", data: {} })

            } else {
                setMsg({
                    show: true,
                    popupStatus: "Please Try Again",
                    color:"#ff0000"
                })
            }
            setTimeout(() => {
                setMsg({
                    show: false,
                    popupStatus: "",
                    color:""
                })
            }, 3000)
        })
    }

    useEffect(() => {
        getWhatsappTemplateForEvFn()
    }, [])

    const getWhatsappTemplateForEvFn = () => {
        setLoader(true)
        getWhatsappTemplateForEv(callback => {
            setLoader(false)
            console.log("call", callback)
            setTemplateList(callback?.data)
        })
    }

    const getCommunicationPreiviwTempalteByTemplateIdFn = (id) => {
        setLoader(true)
        getCommunicationPreiviwTempalteByTemplateId(id, "WHATSAPP", userDetail?.userId, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setPreviewData(callback?.data)
            } else {
                setPreviewData("")
            }
        })
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            <div className="details-new container-fluid">
                <div className='sms-box'>
                    <label style={{ fontSize: '10px', fontWeight: '500' }}>Select Template</label>
                    <select

                        style={{ width: '100%', background: '#DBE9FF', color: '#000', outline: 'none' }}
                        name="communicationMsg"
                        value={selectedTemplate?.value}
                        onChange={(e) => handleSelectedMsg(e)}
                        className='form-control'
                    >
                        <option value="">Select a template</option>
                        {
                            templateList?.length > 0 ? templateList?.map((val, id) => {
                                return (
                                    <option value={val?.whatsappId}>{val?.whatsappSubject?.replace(/_/g, " ")}</option>
                                )
                            })
                                : ''}

                    </select>

                    <label style={{ fontSize: '10px', fontWeight: '500', marginTop: '10px' }}>Preview</label>
                    <div className="relative_position" style={{}}>
                        <div className="whatsapp-msg" id="whatsappMsg" style={{ paddingBottom: window.innerHeight < 650 ? '200px' : '20px', overflow: 'auto', maxHeight: window.innerHeight < 650 ? '400px' : '600px', overflowY: 'auto' }}>
                            <div className="margin-0 row">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: previewData
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>
                    {
                        selectedTemplate?.value !== "" && selectedTemplate?.value !== null && selectedTemplate?.value !== undefined ?
                            <>
                                <div style={{
                                    paddingTop: '20px'
                                }}>
                                    <div className='row'>

                                        <div className='col-sm-12 col-xs-12 text-center'>
                                            <button className='btn btn-primary' style={{ margin: '0' }} onClick={e => SendMsg(e)}>
                                                Send &nbsp;
                                                <span className="fa fa-paper-plane"  />
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </>
                            : ""}
                </div>
                {
                    Msg?.show ?
                        <p style={{color:Msg?.color}} className="text-center height-20px margin-0 red-text">{Msg?.popupStatus}</p>
                        : ""}

            </div>
        </>
    )
}
